/* Ceela motion.
   1. Lazy video loops: files load only when near the viewport, play muted, pause off-screen.
   2. The sunrise: timeline steps light up in order and the sun climbs with them.
   3. Arrivals: elements marked data-rise fade up once as they enter.
   4. Pointer light on glass cards (desktop only).
   Everything re-scans when the Shopify theme editor re-renders a section, and everything
   stands down for visitors who prefer reduced motion. */
(function () {
  var still = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var hasIO = 'IntersectionObserver' in window;

  /* ---------- 1. lazy video ---------- */
  var vio = null;
  function load(v) {
    if (v.dataset.loaded) return;
    v.querySelectorAll('source[data-src]').forEach(function (s) { s.src = s.getAttribute('data-src'); });
    v.load(); v.dataset.loaded = '1';
  }
  function play(v) { load(v); if (!still) v.play().catch(function () {}); }
  function videos(root) {
    var vids = (root || document).querySelectorAll('video[data-lazy-video]');
    if (!vids.length) return;
    if (!hasIO) { vids.forEach(play); return; }
    if (!vio) {
      vio = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) play(e.target);
          else if (!e.target.paused) e.target.pause();
        });
      }, { rootMargin: '240px 0px' });
    }
    vids.forEach(function (v) { if (!v.dataset.observed) { v.dataset.observed = '1'; vio.observe(v); } });
  }

  /* ---------- 2. the sunrise ---------- */
  var tio = null;
  function raiseSun(step) {
    var host = step.closest('[data-sunrise]');
    if (!host) return;
    var all = host.querySelectorAll('.tl__step').length || 1;
    var on = host.querySelectorAll('.tl__step.is-on').length;
    host.style.setProperty('--sun', (on / all).toFixed(3));
  }
  function timeline(root) {
    var steps = (root || document).querySelectorAll('.tl__step');
    if (!steps.length) return;
    if (still || !hasIO) {
      steps.forEach(function (s) { s.classList.add('is-on'); raiseSun(s); });
      return;
    }
    if (!tio) {
      tio = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          var s = e.target, i = parseInt(s.getAttribute('data-i'), 10) || 0;
          setTimeout(function () { s.classList.add('is-on'); raiseSun(s); }, i * 160);
          tio.unobserve(s);
        });
      }, { threshold: 0.55 });
    }
    steps.forEach(function (s, i) { if (!s.dataset.tl) { s.dataset.tl = '1'; s.setAttribute('data-i', i); tio.observe(s); } });
  }

  /* ---------- 3. arrivals ---------- */
  var rio = null;
  function arrivals(root) {
    var els = (root || document).querySelectorAll('[data-rise]');
    if (!els.length) return;
    if (still || !hasIO) { els.forEach(function (el) { el.classList.add('is-in'); }); return; }
    if (!rio) {
      rio = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          e.target.classList.add('is-in');
          rio.unobserve(e.target);
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
    }
    els.forEach(function (el) { if (!el.dataset.rise) { el.dataset.rise = '1'; rio.observe(el); } });
  }
  // never leave content hidden if something goes wrong
  setTimeout(function () {
    document.querySelectorAll('[data-rise]:not(.is-in)').forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.top < window.innerHeight) el.classList.add('is-in');
    });
  }, 2500);

  /* ---------- 4. pointer light ---------- */
  if (!still && window.matchMedia && window.matchMedia('(hover:hover) and (pointer:fine)').matches) {
    document.addEventListener('pointermove', function (e) {
      var card = e.target.closest && e.target.closest('.spot');
      if (!card) return;
      var r = card.getBoundingClientRect();
      card.style.setProperty('--mx', (e.clientX - r.left) + 'px');
      card.style.setProperty('--my', (e.clientY - r.top) + 'px');
    }, { passive: true });
  }

  function scan(root) { videos(root); timeline(root); arrivals(root); }
  scan();
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
  document.addEventListener('shopify:section:select', function (e) { scan(e.target); });
})();
